import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100px;
  width: 100%;
  position: absolute;
  bottom: 50%;
  z-index: 3;

  ${({ background }) =>
    background &&
    `background-image: url(${background});
    background-size: cover;
    background-repeat: no-repeat`};
`;
